import { Env } from 'types/env/Env.type';
import {
  activeScenarioTabAtom,
  currencyCountryCodeAtom,
  googleApiKeyAtom,
  currencyPrefixAtom,
  jotaiStore,
  setJotaiStore,
  supportEmailAtom,
  minimumScreenSizeAtom,
  enableOptionsAndComparisons,
  mobileBreakPoint,
  unavailableFundAtom,
  logLevel
} from './jotai.store';
import { LogLevel } from '@sanlam-glacier/app-common/modules/logger';

interface EnvironmentService {
  getLogLevel: () => LogLevel;
  getCurrencyCode: () => string;
  getCurrencyPrefix: () => string;
  getUnavailableFundText: () => string;
  getGoogleApiKey: () => string;
  getSupportEmail: () => string;
  setStore: (environmentConfig: Env) => void;
  userPreferences: UserPreferences;
  getMinimumScreenSize: () => number;
  getMobileBreakPoint: () => number;
  getEnableOptionsAndComparisons: () => boolean;
}

interface UserPreferences {
  getActiveScenarioTab: (initialValue: string | undefined) => string | undefined;
  setActiveScenarioTab: (value: string | undefined) => void;
}

export const environmentService: EnvironmentService = {
  getCurrencyCode: (): string => jotaiStore.get(currencyCountryCodeAtom),
  getGoogleApiKey: (): string => jotaiStore.get(googleApiKeyAtom),
  getCurrencyPrefix: (): string => jotaiStore.get(currencyPrefixAtom),
  getLogLevel: (): LogLevel => jotaiStore.get(logLevel),
  getUnavailableFundText: (): string => jotaiStore.get(unavailableFundAtom),
  getSupportEmail: (): string => jotaiStore.get(supportEmailAtom),
  setStore: (environmentConfig: Env): void => {
    setJotaiStore(environmentConfig);
  },
  getMinimumScreenSize: (): number => jotaiStore.get(minimumScreenSizeAtom),
  getMobileBreakPoint: (): number => jotaiStore.get(mobileBreakPoint),
  getEnableOptionsAndComparisons: (): boolean => jotaiStore.get(enableOptionsAndComparisons),
  userPreferences: {
    getActiveScenarioTab: (initialValue: string | undefined) => {
      const value = jotaiStore.get(activeScenarioTabAtom);
      if (!value) {
        jotaiStore.set(activeScenarioTabAtom, initialValue);
        return initialValue;
      }
      return value;
    },
    setActiveScenarioTab: (value: string | undefined) => {
      jotaiStore.set(activeScenarioTabAtom, value);
    }
  }
};
